import MarketingTile from 'components/Catalog/ProductGrid/MarketingTile/MarketingTile';

export default MarketingTile;
